/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {
  Box,
  Grid,
  withStyles,
} from '@material-ui/core';

export const StyledAppContainer = withStyles((theme) => ({
  root: {
    height: '100vh',
  },
}))(Grid);

export const StyledContentContainer = withStyles((theme) => ({
  root: {
    backgroundColor: '#031630',
    height: '100%',
    borderRadius: 3,
    color: 'white'
  },
}))(Box);
export const StyledSettingsContainer = withStyles((theme) => ({
  root: {
    backgroundColor: '#031630',
    borderRadius: 3,
    color: 'white',
  },
}))(Box);

export const StyledTabContainer = withStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    borderRadius: 3,
    color: 'white',
    '& .MuiTabs-indicator': {
      backgroundColor: '#007636'
    }
  },
}))(Box);

export const StyledTableWrapper = withStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxHeight: 'calc(100vh - 200px)'
  },
}))(Box);